/*
 * Copyright (c) 2020. FINN Sp. z o.o.
 */

package pl.finn.forms.sekap1794

import io.kvision.form.upload.UploadInput
import io.kvision.html.Button
import io.kvision.modal.Confirm
import io.kvision.redux.createReduxStore
import io.kvision.utils.getContent
import kotlinx.browser.window
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import pl.finn.forms.*

object Model : CoroutineScope by CoroutineScope(Dispatchers.Default + SupervisorJob()) {

  val formsService = FormsService()
  val sekap1794Service = Sekap1794Service()

  val formularzStore =
    createReduxStore(
      ::formularzReducer,
      Formularz(FormularzWidok.PUSTY)
    )

  fun nowy(token: String, app: App) {
    launchWithProgress {
      val formData = sekap1794Service.nowy(token)
      formularzStore.dispatch(FormularzAction.Nowy(formData))
      app.aktywujSekap1794()
      window.scrollTo(0.0, 0.0)
    }
  }

  fun zapisz(form: Sekap1794Form, validateResult: String?) {
    launchWithProgress {
      val state = formularzStore.getState()
      val url = sekap1794Service.zapisz(form, state.zalaczniki ?: emptyList(), validateResult, state.token!!)
      window.location.href = url
    }
  }

  fun podglad(form: Sekap1794Form, button: Button) {
    launchWithProgress {
      val state = formularzStore.getState()
      val xml = sekap1794Service.podglad(form, state.zalaczniki ?: emptyList(), state.token!!)
      PodgladWindow(state.token).pokazTresc(xml, button)
    }
  }

  fun edycja(token: String, app: App) {
    launchWithProgress {
      val formData = sekap1794Service.edycja(token)
      formularzStore.dispatch(FormularzAction.Edycja(formData))
      app.aktywujSekap1794()
      window.scrollTo(0.0, 0.0)
    }
  }

  fun anuluj() {
    launchWithProgress {
      val state = formularzStore.getState()
      val url = formsService.anuluj(state.token!!)
      window.location.href = url
    }
  }

  fun dodajZalacznik(zalacznik: UploadInput, opisZalacznika: String?, form: Sekap1794Form) {
    launchWithProgress {
      zalacznik.value?.firstOrNull()?.let {
        val dataContent = zalacznik.getNativeFile(it)?.getContent()
        val parts = dataContent?.split(",")
        val mime = parts?.get(0)?.drop(5)?.dropLast(7)
        val content = parts?.getOrNull(1)
        formularzStore.dispatch(
          FormularzAction.DodajZalacznik(
            Zalacznik(
              it.name,
              opisZalacznika,
              mime,
              content
            ), form
          )
        )
      }
    }
  }

  fun usunZalacznik(nazwa: String, form: Sekap1794Form) {
    Confirm.show(
      "Potwierdzenie",
      "Czy na pewno usunąć wybrany załącznik?",
      yesTitle = "Tak",
      noTitle = "Nie"
    ) {
      formularzStore.dispatch(FormularzAction.UsunZalacznik(nazwa, form))
    }
  }
}
